// extracted by mini-css-extract-plugin
module.exports = {"header":"SafariOverviewHeader_header__1mRRa","separator":"SafariOverviewHeader_separator__ai1qE"};